import {Ionicons} from '@expo/vector-icons';
import {InterfaceTextProps} from 'native-base/src/components/primitives/Text/types';
import React from 'react';
import * as Clipboard from 'expo-clipboard';
import {Text, Toast, useTheme} from 'native-base';
import {t} from 'react-native-tailwindcss';
import i18n from '../lib/i18n';

interface Props extends InterfaceTextProps {
  value?: string;
}

export const Copiable: React.FC<Props> = ({children, value, ...rest}) => {
  const {colors} = useTheme();
  const handlePress = () => {
    Clipboard.setString(value || String(children));
    Toast.show({
      description: i18n.t('copied'),
      duration: 1500
    });
  };
  return (
    <Text {...rest}>
      {children}{' '}
      <Ionicons
        color={colors.primary['500']}
        style={[t.mL2]}
        size={16}
        onPress={handlePress}
        name="copy-outline"
      />
    </Text>
  );
};
